/**
 * Tiny type chip for an org unit — Company / Function / Department.
 *
 * Used wherever a unit is shown by name alone (e.g. the parent-unit picker in
 * the structure editors) so you can tell a Function from a Department at a
 * glance instead of guessing from the name. Each type gets a distinct Badge
 * variant so the three read as clearly different.
 */
import type { OrgUnitType } from '@lms/shared-types'
import { Badge, type BadgeVariant } from '../../primitives/Badge'

export const UNIT_TYPE_LABEL: Record<OrgUnitType, string> = {
  company: 'Company',
  function: 'Function',
  department: 'Department',
}

const TYPE_VARIANT: Record<OrgUnitType, BadgeVariant> = {
  company: 'navy',
  function: 'blue',
  department: 'pear',
}

export function UnitTypeChip({ unitType }: { unitType: OrgUnitType }): JSX.Element {
  return <Badge variant={TYPE_VARIANT[unitType]}>{UNIT_TYPE_LABEL[unitType]}</Badge>
}
